import axiosPost from "./axiosPost";

export const PaisGet = async (credentials) => {
    const body = {
        "service": "PaisGet",
        "params": { }
    };

    try {
        const result = await axiosPost('Y', body, credentials)
       
        return result
    } catch (err) {
        console.log(err)
    }
};